export enum InstalledModulesEnum {
  AD = 'AD',
  DIC = 'DIC',
  BASIC = 'BASIC',
  RCAF = 'RCAF',
  CMMS = 'CMMS',
  CMMS_SIMULATOR = 'CMMS_SIMULATOR',
  CMMS_PTA = 'CMMS_PTA',
  SHD = 'SHD',
  SHD_LIGHT = 'SHD_LIGHT',
  BLE_DEFAULT = 'BLE_DEFAULT',
  BLE_NOE = 'BLE_NOE',
  OKE_PIMS_URL = 'OKE_PIMS_URL',
  ABB_DEFAULT_DS = 'ABB_DEFAULT_DS',
  MULTI_SITE_FILTER = 'MULTI_SITE_FILTER',
  OKE_ABB_BLOCKLOG_INTEGRATION = 'OKE_ABB_BLOCKLOG_INTEGRATION',
  ABP_CDF_BLOCKLOG_INTEGRATION = 'ABP_CDF_BLOCKLOG_INTEGRATION',
}
